import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import {
  actions,
  createNarratorMultilingualAsync,
  editNarratorMultilingualAsync,
  getNarratorByIdMultilingualAsync,
} from './slices';

export const createNarratorMultilingual = async (
  data: Server.CreateNarratorV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(createNarratorMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editNarratorMultilingual = async (
  data: Server.EditNarratorV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editNarratorMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getNarratorByIdMultilingual = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getNarratorByIdMultilingualAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const clearNarratorByIdMultilingual = async () => {
  store.dispatch(actions.clearByIdMultilingual());
};
